<template>
  <div
    class="topbar w-full lg:h-12 flex justify-center items-center bg-red-500 overflow-hidden relative py-2 px-4 lg:py-0"
    v-if="isAdblock"
  >
    <Icon
      name="Exclamation"
      class="w-24 h-24 text-red-600 transform rotate-45 absolute"
    />
    <div
      class="w-10 h-10 rounded-lg bg-red-600 mr-3 grid place-content-center relative z-10"
    >
      <Icon name="Exclamation" class="w-8 h-8 text-white" />
    </div>
    <p class="text-white text-base relative z-10 leading-tight">
      <span class="font-medium text-lg text-blue-900">Warning</span>
      Having issues seeing the ads? Please disable any
      <strong>Adblock</strong> extension :)
    </p>
    <Icon
      name="Ban"
      class="icon_ban w-20 h-20 text-red-600 transform rotate-8 absolute mt-10"
    />
    <Icon
      name="Exclamation"
      class="w-32 h-32 text-red-600 transform -rotate-45 absolute right-0"
    />
    <Icon
      name="Close"
      class="w-8 h-8 text-white hover:opacity-75 absolute right-0 mr-4 cursor-pointer"
      @click="hiddenTopbar"
    />
  </div>
</template>

<script>
import Icon from "@/components/UI/Icon";
import { computed, onMounted, ref } from "vue";
import { useStore } from "vuex";
import AdblockDetector from "adblock-detector";
export default {
  components: { Icon },
  setup() {
    const store = useStore();
    const userHasAdblock = AdblockDetector.detect();

    onMounted(async () => {
      if (userHasAdblock) {
        if (advertisements.value === null) isAdblock.value = true;
      }
    });

    const advertisements = computed(() => store.state.advertisements);
    const isAdblock = ref(false);

    const hiddenTopbar = () => {
      isAdblock.value = false;
    };

    return { advertisements, isAdblock, hiddenTopbar };
  },
};
</script>

<style scoped>
.topbar {
  box-shadow: inset 0 -1px 10px 0 rgba(0, 0, 0, 0.2);
}
.topbar > svg {
  z-index: 1;
}
.topbar > svg:first-child {
  left: 15vw;
}
.icon_ban {
  right: 20vw;
}

.topbar > div > svg {
  animation-name: exclamation;
  animation-duration: 0.6s;
  animation-iteration-count: infinite;
  animation-direction: alternate;
}
@keyframes exclamation {
  from {
    @apply w-6 h-6;
  }
  to {
    @apply w-8 h-8;
  }
}
</style>
